export var DevPlanStatusTypes;
(function (DevPlanStatusTypes) {
    DevPlanStatusTypes["ACTIVE"] = "active";
    DevPlanStatusTypes["PAST_DUE"] = "past_due";
    DevPlanStatusTypes["TRIALING"] = "trialing";
    DevPlanStatusTypes["CANCELED"] = "canceled";
    DevPlanStatusTypes["INCOMPLETE"] = "incomplete";
    DevPlanStatusTypes["INCOMPLETE_EXPIRED"] = "incomplete_expired";
    DevPlanStatusTypes["UNPAID"] = "unpaid";
    DevPlanStatusTypes["UNSET"] = "unset";
    DevPlanStatusTypes["ERROR"] = "error";
})(DevPlanStatusTypes || (DevPlanStatusTypes = {}));
export var ModalType;
(function (ModalType) {
    ModalType["WELCOME"] = "welcome";
    ModalType["CONFIGURE"] = "configure";
    ModalType["SELECT"] = "select";
    ModalType["PAYMENT"] = "payment";
    ModalType["CONTACT"] = "contact";
})(ModalType || (ModalType = {}));
